import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { edit_profile_thunk } from "../redux/auth/authThunk";
import { USER_AU_USER } from "../common/key";
import { FaArrowLeft, FaSave, FaUser } from "react-icons/fa";

const EditProfile = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    address: "",
    bankDetails: {
      bankName: "",
      accountHolderName: "",
      accountNumber: "",
      routingNumber: "",
      swiftCode: "",
      ibanNumber: "",
    },
  });

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Load user data from localStorage
    const userDataString = localStorage.getItem(USER_AU_USER);
    if (userDataString) {
      try {
        const userData = JSON.parse(userDataString);
        setFormData({
          firstName: userData.firstName || "",
          lastName: userData.lastName || "",
          email: userData.email || "",
          address: userData.address || "",
          bankDetails: {
            bankName: userData.bankDetails?.bankName || "",
            accountHolderName: userData.bankDetails?.accountHolderName || "",
            accountNumber: userData.bankDetails?.accountNumber || "",
            routingNumber: userData.bankDetails?.routingNumber || "",
            swiftCode: userData.bankDetails?.swiftCode || "",
            ibanNumber: userData.bankDetails?.ibanNumber || "",
          },
        });
      } catch (error) {
        console.error("Error parsing user data:", error);
      }
    } else {
      // No user data found, redirect to login
      navigate("/");
    }
  }, [navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleBankDetailsChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      bankDetails: {
        ...prev.bankDetails,
        [name]: value,
      },
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await dispatch(edit_profile_thunk(formData)).unwrap();
      navigate("/dashboard");
    } catch (error) {
      console.error("Error updating profile:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen w-screen bg-gray-900 text-white overflow-y-auto">
      {/* Header - Similar style to Dashboard header */}
      <header className="bg-black text-white py-3 px-4 md:px-6 flex justify-between items-center shadow-lg border-b border-gray-800">
        <div className="flex items-center space-x-3">
          <button
            onClick={() => navigate("/dashboard")}
            className="text-gray-400 hover:text-purple-400"
            title="Back to Dashboard"
          >
            <FaArrowLeft className="h-5 w-5" />
          </button>
          <div className="flex items-center">
            <FaUser className="h-6 w-6 text-purple-500" />
            <h1 className="text-xl md:text-2xl font-bold tracking-wider ml-2 bg-clip-text text-transparent bg-gradient-to-r from-purple-400 to-pink-500">
              Edit Profile
            </h1>
          </div>
        </div>
      </header>

      {/* Content Area */}
      <div className="max-w-3xl mx-auto px-4 py-6">
        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="bg-gray-800 rounded-lg shadow-lg p-6 border border-gray-700">
            <h2 className="text-xl font-semibold mb-4 text-purple-400">
              Personal Information
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-medium text-gray-300 mb-1">
                  First Name
                </label>
                <input
                  type="text"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  className="w-full px-4 py-2 bg-gray-700 border border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 text-white"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-300 mb-1">
                  Last Name
                </label>
                <input
                  type="text"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  className="w-full px-4 py-2 bg-gray-700 border border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 text-white"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-300 mb-1">
                  Email
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full px-4 py-2 bg-gray-700 border border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 text-white"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-300 mb-1">
                  Address
                </label>
                <input
                  type="text"
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                  className="w-full px-4 py-2 bg-gray-700 border border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 text-white"
                />
              </div>
            </div>
          </div>

          {/* <div className="bg-gray-800 rounded-lg shadow-lg p-6 border border-gray-700">
            <h2 className="text-xl font-semibold mb-4 text-purple-400">
              Bank Details
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-medium text-gray-300 mb-1">
                  Bank Name
                </label>
                <input
                  type="text"
                  name="bankName"
                  value={formData.bankDetails.bankName}
                  onChange={handleBankDetailsChange}
                  className="w-full px-4 py-2 bg-gray-700 border border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 text-white"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-300 mb-1">
                  Account Holder Name
                </label>
                <input
                  type="text"
                  name="accountHolderName"
                  value={formData.bankDetails.accountHolderName}
                  onChange={handleBankDetailsChange}
                  className="w-full px-4 py-2 bg-gray-700 border border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 text-white"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-300 mb-1">
                  Account Number
                </label>
                <input
                  type="text"
                  name="accountNumber"
                  value={formData.bankDetails.accountNumber}
                  onChange={handleBankDetailsChange}
                  className="w-full px-4 py-2 bg-gray-700 border border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 text-white"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-300 mb-1">
                  Routing Number
                </label>
                <input
                  type="text"
                  name="routingNumber"
                  value={formData.bankDetails.routingNumber}
                  onChange={handleBankDetailsChange}
                  className="w-full px-4 py-2 bg-gray-700 border border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 text-white"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-300 mb-1">
                  Swift Code
                </label>
                <input
                  type="text"
                  name="swiftCode"
                  value={formData.bankDetails.swiftCode}
                  onChange={handleBankDetailsChange}
                  className="w-full px-4 py-2 bg-gray-700 border border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 text-white"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-300 mb-1">
                  IBAN Number
                </label>
                <input
                  type="text"
                  name="ibanNumber"
                  value={formData.bankDetails.ibanNumber}
                  onChange={handleBankDetailsChange}
                  className="w-full px-4 py-2 bg-gray-700 border border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 text-white"
                />
              </div>
            </div>
          </div> */}

          <div className="flex justify-end">
            <button
              type="button"
              onClick={() => navigate("/dashboard")}
              className="px-6 py-2.5 mr-4 bg-gray-700 hover:bg-gray-600 rounded-md text-white font-medium transition-colors"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={loading}
              className="px-6 py-2.5 bg-gradient-to-r from-purple-500 to-pink-500 hover:from-purple-600 hover:to-pink-600 rounded-md text-white font-medium transition-colors flex items-center disabled:opacity-50"
            >
              {loading ? (
                "Saving..."
              ) : (
                <>
                  <FaSave className="mr-2" />
                  Save Changes
                </>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditProfile;
